export default "https://d3nn82uaxijpm6.cloudfront.net/packs/media/apps/subscriptions/Checkout/components/Form/assets/visa-0e304697af7b1775b2dcd8d9684e0040.svg";